<template>  
    <div class="section">
        <h1 
            class="is-size-1-desktop is-hidden-touch has-text-centered has-text-white quote"
            style="margin-bottom:120px;margin-top:50px;"
            >
            Dagmøter for inntil 36 gjester
        </h1>

        <div class="bak is-hidden-desktop" style="margin-bottom:50px;">
            <h1 
                class="is-size-3-touch is-hidden-desktop has-text-centered has-text-white quote"
                >
                Dagmøter for inntil 36 gjester
            </h1>
        </div>       

        <div class="bak2" style="padding: 30px 60px 30px 60px;">
            <p class="is-size-4 is-size-5-touch has-text-white">
                For tiden har vi plass til maksimalt 50 personer til dagmøter her på huset. For møter med overnatting eller strømmebehov, vennligst ta kontakt for et konkret tilbud. Hva bordoppsett angår hersker det flere begrensninger enn normalt ettersom vi er veldig opptatt av smittevern.
            </p>
            <p class="is-size-4 is-size-5-touch has-text-white">
                Dagmøtepakken inneholder møterom, kaffe/te igjennom hele møtet, Internett til alle møtedeltagere, gratis parkering samt en flaske mineralvann til lunsj. Ekstra mineralvann, lunsj og pausemat kommer i tillegg. Alle grupper må velge en av våre lunsjmenyer. Pausematmenyer velges etter ønske og behov.
            </p>
            <p class="is-size-4 is-size-5-touch has-text-white">
                Prisen på dagmøtepakken er kr. 290,-/person pluss <a href="/meny" target="_self"> en lunsj fra denne menyen</a> og eventuelt noe fra pausematmenyen under.
            </p>
            <p class="is-size-4 is-size-5-touch has-text-white">
                <span class="has-text-weight-bold">Pausematmeny</span><br/>                
                Frukt og smoothies – kr. 45,-<br/>
                Brownies – kr. 45,-<br/>
                Hjemmebakte kanelsnurrer kr. 45,-
                <br/><br/>
                <em>Alle priser er inklusive mva.</em>
            </p>
        </div> 

        <div class="has-text-centered" style="margin-top:100px;margin-bottom:80px;">   
            <a 
                href="mailto:booking@generalhotell.no?subject=Forespørsel%20fra%20nettsiden"
                class="button is-primary is-large has-text-white"
                alt="Send oss en forespørsel"
                >
                Send oss en forespørsel nå!
            </a>
        </div>          

    </div>
</template>

<script>
export default {
    name: 'Dagmoter', 
    title: 'Dagmøte på hotellet - rimelige konferansepakke',
    metaInfo: {
        meta: [
        { name: 'description', content: 'Kurs og konferanse på General Hotell. 2 konferansesaler og 2 flotte grupperom. Vi lager den ultimate konferansepakken uten å tømme lommeboken din. Vi tilbyr også digitale møter og gode streamingløsninger.'},
        { name: 'keywords', content: 'konferanse, kurs, seminar, møte, frokostmøte, kick-off, konferansehotell, møtepakker, møtepakke, hotell, konferanse senter, streaming, strømmetjenester, strømming, digitale møter' }
        ]
    }    
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.5;
    display: block;
    padding: 10px 10px 10px 10px;
}

.bak2 {
    background-color: #000;
    opacity: 0.8;
    display: block;
    padding: 10px 10px 10px 10px;
}

p {
    margin-bottom:30px;
}

</style>